import * as React from 'react';

import type {GetPrimaryContextDocument_primaryContextDocument_aiSuggestions as AiSuggestionType} from 'nutshell-graphql-types';

import {hexToRgba} from '../../../../../ui/forms/helpers';

import {colors} from '../colors/colors';
import {Stack} from '../layout/stack/stack';
import {LoadingText} from '../loading-placeholder/loading-text';

import {DEFAULT_SUGGESTIONS} from './consts';

import styles from './chat-preview.module.css';

type Props = {
    suggestions: Array<AiSuggestionType>;
    secondaryColor: string;
    isLoading: boolean;
    alignItems?: 'start' | 'end' | 'center';
    isHorizontal?: boolean;
};

export function ChatNudges(props: Props) {
    const {alignItems = 'end', isHorizontal = false} = props;
    let suggestions = DEFAULT_SUGGESTIONS;

    if (props.suggestions && props.suggestions.length >= 3) {
        // @ts-expect-error
        suggestions = props.suggestions.map(
            (suggestion) => (suggestion && suggestion.content) || ''
        );
    }

    if (props.isLoading) {
        return (
            <Stack spacing={8} alignItems='end'>
                <LoadingText height={35} width={250} color={hexToRgba(props.secondaryColor, 0.3)} />
                <LoadingText height={35} width={250} color={hexToRgba(props.secondaryColor, 0.3)} />
                <LoadingText height={35} width={250} color={hexToRgba(props.secondaryColor, 0.3)} />
            </Stack>
        );
    }

    const borderAndTextColor =
        props.secondaryColor.toLowerCase() === colors.white.toLowerCase()
            ? colors.black
            : props.secondaryColor;

    return (
        <Stack spacing={8} alignItems={alignItems} isHorizontal={isHorizontal}>
            {suggestions.map((suggestion) => (
                <div className='background-white br-8' key={suggestion}>
                    <div
                        style={{
                            border: `1px solid ${borderAndTextColor}`,
                            color: borderAndTextColor,
                            backgroundColor: hexToRgba(props.secondaryColor, 0.1),
                        }}
                        className={styles['chat-bubble--suggestion']}
                    >
                        {suggestion}
                    </div>
                </div>
            ))}
        </Stack>
    );
}
